<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/5zLKLn/html/docimages/cover_ader.jpg?1684274265129" alt="This image is the cover for the book Gardens of Karma"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Gardens of Karma
      </h1>
      <p class="bookDescription body article font2">
        <p>It Began in a Simple Garden . . . and Led to a Spiritual Path. Susan West Kurz's earliest memories began in a garden, where she nurtured herbs and colorful flowers, nibbled sun-drenched vegetables and ripe berries, and danced with her doll, Pinocchio. Later, she landed in another garden, that one in Germany, where she shaped her budding interest into a hugely successful career for international organic and natural skin care products. But for decades, Susan was steeped in another role-one of enabler, support system, and overall back-up singer to the alcoholics who were center stage in her life. The pain of that disease ultimately led her to Anthroposophy, her spiritual path, where she soon recognized she had been headed all along. On her subsequent journey to health and freedom, Susan continues to find inner peace in a garden.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Susan West Kurz
      </h2>
      
      <p class="authorDescription body article">Susan West Kurz and her husband Clifford divide their time between Jamestown, Rhode Island, and Ocala, Florida. She is the author of Awakening Beauty the Dr. Hauschka Way and Beecoming Sophie, a graphic novel about saving the honeybees. She is a certified facilitator for Biography and Social Art. You can learn more about Susan at biographyandsocialart.com.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      White River Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?cbe2d550